/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Image from '@components/global/Image';
import Colors from '@global/colors';
import PropTypes from 'prop-types';

const propTypes = {
  image: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  width: PropTypes.number,
  height: PropTypes.number,
  touchable: PropTypes.bool,
  bordered: PropTypes.bool,
  borderWidth: PropTypes.number,
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  onPress: PropTypes.func,
};

const defaultProps = {
  image: '',
  width: 40,
  height: 40,
  touchable: false,
  bordered: false,
  borderWidth: 5,
  style: {},
  onPress: () => {},
};

const PhotoDefault = (props) => {
  const {
    image,
    width,
    height,
    touchable,
    bordered,
    borderWidth = 5,
    style,
    onPress,
  } = props;
  const [source, setSource] = useState('');

  useEffect(() => {
    let mounted = true;
    if (mounted && image != source) {
      setSource(image ? image : '');
    }
    return () => {
      mounted = false;
    };
  }, [image]);

  const onClick = () => {
    try {
      onPress();
    } catch (error) {}
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        activeOpacity={touchable ? 0.6 : 1}
        style={[
          bordered
            ? {
                borderWidth: borderWidth,
                borderColor: Colors.white,
              }
            : {},
          {
            width: width,
            height: height,
            borderRadius: width,
          },
          styles.imageContainer,
          style,
        ]}
        onPress={() => (touchable ? onClick() : null)}>
        <Image
          style={{
            width: width,
            height: height,
            marginLeft: bordered ? -borderWidth : 0,
          }}
          compressWidth={150}
          width={width}
          height={height}
          source={source}
          centered
          isPhoto
        />
      </TouchableOpacity>
      {touchable ? (
        <View style={styles.plus}>
          <Image
            style={{ width: 24, height: 24 }}
            width={24}
            height={24}
            svg
            source={require('@assets/img/icons/plus-upload.svg')}
          />
        </View>
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { position: 'relative' },
  imageContainer: {
    backgroundColor: Colors.grey0,
    justifyContent: 'center',
    marginRight: 15,
    overflow: 'hidden',
  },
  plus: {
    position: 'absolute',
    bottom: '11%',
    right: '12%',
  },
});

PhotoDefault.propTypes = propTypes;
PhotoDefault.defaultProps = defaultProps;

export default PhotoDefault;
